"use client";

import useActionKeyStore from "@/stores/actionKeyStore";
import { ethers } from "ethers";

export function useActionKey() {
  const { expiredAt, actionPublicKey, actionPrivateKey, setActionKey } =
    useActionKeyStore();

  const generateActionKey = (timestamp: number) => {
    const expiredAt = Date.now() + 1000 * 60 * 60 * 24;
    const wallet = ethers.Wallet.createRandom();

    const actionPublicKey = wallet.publicKey;
    const actionPrivateKey = wallet.privateKey;
    return {
      expiredAt,
      actionPublicKey,
      actionPrivateKey,
    };
    // setActionKey(expiredAt, actionPublicKey, actionPrivateKey);
  };

  return {
    expiredAt,
    actionPublicKey,
    actionPrivateKey,
    setActionKey,
    generateActionKey,
  };
}
